import { tns } from '../../_scripts/plugins/tiny-slider/tiny-slider.js';

export default class Journal {

  constructor() {
    this.timeline = document.querySelector('.timeline');
    this.timelineList;
    this.timelineSelect = document.querySelector('.timeline__select');
    this.slider;
  }

  _removeActiveFilter() {
    [...this.timelineSelect.options].map(option => {
      option.removeAttribute('selected');
    });

    [...document.querySelectorAll('.timeline__item')].map(item => {
      item.classList.remove('timeline__item--active');
    });

  }

  _getNumberSlide(currentItem) {
    const slideNumber = Number(currentItem.getAttribute('id').match(/\d+/g)[1]);
    this.slider.goTo(slideNumber);
  }

  _tinySlider() {
    const slider = tns({
      autoWidth: true,
      loop: false,
      mouseDrag: true,
      container: this.timelineList,
      controls: false,
      swipeAngle: false,
      speed: 400,
      nav: false,
      autoPlay: false,
      cancelable: false,
      responsive: {
        1025: {
          disable: true
        },
      }
    });
    this.slider = slider;
  }

  _createJournalList() {
    const createTimelineList = document.createElement('ul');
    createTimelineList.setAttribute('class', 'timeline__list');

    [...this.timelineSelect.options].map((option, i) => {
      const createTimelineItem = document.createElement('li');
      createTimelineItem.setAttribute('class', 'timeline__item');
      createTimelineItem.innerHTML = option.innerHTML;

      option.selected
        && (
          option.setAttribute('selected', ''),
          createTimelineItem.classList.add('timeline__item--active')
        );
      this._timelineItemHandler(createTimelineItem, option);

      createTimelineList.appendChild(createTimelineItem);
    });

    this.timeline.appendChild(createTimelineList);
    this.timelineList = document.querySelector('.timeline__list');
    this._tinySlider();
  }

  _timelineItemHandler(createTimelineItem, option) {
    createTimelineItem.addEventListener('click', () => {
      this._removeActiveFilter();
      option.selected = createTimelineItem;
      option.setAttribute('selected', '');
      createTimelineItem.classList.add('timeline__item--active');
      this.timeline.submit();

      window.innerWidth <= 1024
        && this._getNumberSlide(createTimelineItem);
    });
  }

  init() {
    this._createJournalList();
  }
}